export default __webpack_public_path__ + "static/media/blue_spinner.e32f9ca8.svg";